<html> 
    <!----------------------------------------------------------------------->
    <body class="dx-viewport">
       
        <!----------------------------------------------------------------------->
        <dx-box
            direction="row"
            width="100%"
            [height]="windowHeight"
            [disabled]="popupactive"
        >
            <!-----------------------------------------------------------------------> 
            <dxi-item
              [ratio]="8"
            >

                <dx-toolbar
                    #toolbaritem
                    id="toolbaritem"

                    width="100%"
                    
                    [elementAttr]="{class: 'toolbarsetting' }"    

                    [visible]="toolbarContentVisible"  
                >

                    <dxi-item  
                        widget="dxButton" 
                        location="before"
                     
                        [options]="menuButtonOption"
                    >
                    </dxi-item>

                    <dxi-item
                        location="center"
                       
                    >
                        <div class="centertext" *dxTemplate>
                            {{formtitle}}
                        </div>

                    </dxi-item>

                    <dxi-item  
                        widget="dxButton" 
                        location="after"
                     
                        [options]="helpButtonOption"
                    >
                    </dxi-item>

                </dx-toolbar>
                <!----------------------------------------------------------------------->
                <div>
                
                  <dx-drawer 
                      id="menuselect"
                      #menuselect
                      [openedStateMode]='selectedOpenMode'
                      [position]='selectedPosition'
                      [revealMode]='selectedRevealMode'
                    
                      template="template"

                      [(opened)]='isDrawerOpen'
                      [height]='windowHeight'
                      [closeOnOutsideClick]='isCloseOutsideClick'

                  >
                    
                    <div *dxTemplate="let data of 'template'" style="width: 290px;">
                        
                          <div *ngIf="menuopen" class="listborder listitemhover listiconhover listitem"> 
                           
                            
                                <dx-list 
                                    id="listparticipant"
                                    #listparticipant
                                    [dataSource]='navigationfilter'

                                    [visible]="listvisible"

                                    [hoverStateEnabled]='true'
                                    [activeStateEnabled]='true'
                                    [focusStateEnabled]='true'

                                    height="100%"
                                
                                    [grouped]='true'

                                    (onItemClick)="menutargetclick($event)"  
                                    
                                    groupTemplate="group"
                                    
                                >
                                    <!----------------------------------------------------------------------->
                                    <div *dxTemplate="let data of 'group'">
                                        <!-- Group header content goes here -->

                                        <div (click)="onGroupClick(data.key)">
                                            
                                            <div ngSwitch="{{listnodestatus[data.indexno]}}">

                                                <div *ngSwitchCase="'L'">

                                                    <div class="oppositeEndsLine">
                                                        <div>{{data.key}}</div>
                                                    </div>

                                                </div>

                                                <div *ngSwitchCase="'O'">

                                                    <div class="oppositeEndsLine">
                                                        <div>{{data.key}}</div>
                                                        <div class="container"><i class="fa-sharp fa-regular fa-circle-up fa-lg"></i></div>
                                                    </div>

                                                </div>
    
                                                <div *ngSwitchCase="'C'">

                                                    <div class="oppositeEndsLine">
                                                        <div>{{data.key}}</div>
                                                        <div class="container"><i class="fa-sharp fa-regular fa-circle-down fa-lg"></i></div>
                                                    </div>
                                                    
                                                </div>
    
                                            </div>
                                         
                                        </div>

                                    </div>
                                    <!----------------------------------------------------------------------->
                                </dx-list>

                              </div>

                    </div>
                    <!----------------------------------------------------------------------->
                    <div>
                        <router-outlet></router-outlet>
                    </div>
                    <!----------------------------------------------------------------------->
                   
                  </dx-drawer>

                </div>
             
                <!----------------------------------------------------------------------->
            </dxi-item>
            <!----------------------------------------------------------------------->
        </dx-box>
        <!----------------------------------------------------------------------->
        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
        <dx-toast
            [(message)]       =   "toastFileMessage"
            [(visible)]       =   "toastVisible"
            [type]            =   "toasttypeerror"
            [displayTime]     =   "toastdisplaytime"  
            [width]           =   "toastwidth" 
        >
                        
            <dxo-position>

                <dxo-at 
                    x="left" 
                    y="top">
                </dxo-at>

                <dxo-offset
                    [x]="150" 
                    [y]="20"
                >
                </dxo-offset>
                
            </dxo-position>

        </dx-toast>
        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
        <dx-popup
            #popregisterevent
            id="popregisterevent"
            [width]="800"
            [height]="550"
            [showTitle]="true"
            title="Register Event Successful"
            [dragEnabled]="true"
            [hideOnOutsideClick]="false"
            [showCloseButton]="true"

            [(visible)]="popregistereventVisible"
        >

            <span>Please JOT down your:</span>

            <dx-text-box
                label="Email Address"
                [readOnly]="true"
                [value]="eventemail"
                width="90%"
                height="20px"
            >
            </dx-text-box>

            <dx-text-box
                label="Password"
                [readOnly]="true"
                [value]="eventpassword"
                width="90%"
                height="20px"
            >
            </dx-text-box>

            You will need these to log in


        </dx-popup>
        <!------------------------------------------------------------------------->
        <dx-popup
            #faqpopup
            [title]="faqtitle"
            width="45%"
            [height]="windowHeightFAQ"
            
            [showTitle]="true"
            [dragEnabled]="true"
            [closeOnOutsideClick]="false"

            [shading]="true"
            
            [(visible)]="popfaq"
                        
            (onHiding)="popuphide($event)"
        >
            <!------------------------------------------------------------------------->
            <dxo-position
                of="#toolbaritem"
            >

                <dxo-my 
                    x="left" 
                    y="top"
                >
                </dxo-my>

                <dxo-offset 
                    [x]="45" 
                    [y]="0">
                </dxo-offset>

            </dxo-position>
            <!------------------------------------------------------------------------->
            <dx-accordion
                #accordion
                [dataSource]="faqprofile"
                [elementAttr]="{ class: 'faqformatbody' }"
                [collapsible]="true"
                [multiple]="false"
                [animationDuration]="300"

                [(selectedIndex)]="faqitem"

                (onItemClick)="accordiontargetclick( $event )"
            
            >

                <div *dxTemplate="let faqtitle of 'title'">
                    <span style="font-size: 14px; font-weight: bold;">{{faqtitle.title}}</span>
                </div>

                <div *dxTemplate="let faqprofile of 'item'">

                    <div>

                        <!----------------------<div class="faqformat faqformatborder faqformat1">------------------------------------------------>
                        <dx-text-area
                            #faqnote
                            id="fqnote"
                        
                            [autoResizeEnabled]="false"

                            height="20%"

                            [readOnly]="true"
                            
                            value="{{faqprofile.note}}"

                            (onKeyUp)="textareakeypress($event)"
                         
                        >
                        </dx-text-area>
                         <!----------------------<div>------------------------------------------------>

                    </div>

                </div>

            </dx-accordion>
            <!------------------------------------------------------------------------->
        </dx-popup>
        <!----------------------------------------------------------------------->
        <dx-popup
            #faqpopupnote
            id="faqpopupnote"
            title="Note"
            width="45%"
            height="20%"
           
            
            [showTitle]="true"
            [dragEnabled]="true"
            [closeOnOutsideClick]="false"

            [shading]="true"
            
            [(visible)]="popfaqnote"

        >
            <!---------------------------------------------------------------------->
            <dx-text-area
                #faqnote
                id="fqnote"
            
                [autoResizeEnabled]="true"
                [minHeight]="100"
                [maxHeight]="300"

                [readOnly]="true"
                
                [value]="faqnotetext"
            >
            </dx-text-area>
            <!---------------------------------------------------------------------->

        </dx-popup>
        <!--xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx-->
      </body>
    <!----------------------------------------------------------------------->
       
  </html>
  <!----------------------------------------------------------------------->
